import { getPydanticAIFetcher } from "shared/api/api";
import { clientServerPydanticAI } from "shared/api/axios";
import { createURL } from "shared/api/utils";

interface FollowupRequest {
  threadId: string;
  forceRefresh?: boolean;
}

interface FollowupResponse {
  messages?: string[];
}

const getFollowupRequestURI = (threadId: string): string =>
  clientServerPydanticAI.getUri({
    method: "GET",
    url: createURL(["threads", threadId, "followup"]),
  });

export const getFollowup = async ({
  threadId,
  forceRefresh = false,
}: FollowupRequest): Promise<string[]> => {
  try {
    const response = await getPydanticAIFetcher<FollowupResponse>(
      getFollowupRequestURI(threadId),
      forceRefresh ? { params: { force_refresh: true } } : undefined
    );

    return response.data?.messages ?? [];
  } catch {
    return [];
  }
};
